import { render, staticRenderFns } from "./BatimentAssetDetails.vue?vue&type=template&id=4d9da3b8"
import script from "./BatimentAssetDetails.vue?vue&type=script&lang=js"
export * from "./BatimentAssetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports